<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<!-- Start of footer section -->
<div class="footer">
  <div class="copyright-links">
    <a (click)="openSuiteCopyright(suitecopyright)" class="footer-link" data-toggle="modal"
       data-target=".copyright-suitecrm">
      &copy; Supercharged by SuiteCRM
    </a>
    <a (click)="openSugarCopyright(sugarcopyright)" class="footer-link" data-toggle="modal"
       data-target=".copyright-sugarcrm">
      &copy; Powered By SugarCRM
    </a>
  </div>
  <ng-container *ngIf="this.isUserLoggedIn">
    <div class="back-to-top">
      <a (click)="backToTop()" class="footer-link">
        <span>
          Back To Top
          <scrm-image class="sicon back-top-icon" image="arrow_up_filled"></scrm-image>
        </span>
      </a>
    </div>
  </ng-container>
</div>
<!-- End of footer section -->

<!-- Start of copyright modal section -->

<div class="copyright">

    <!-- Start of SugarCRM Copyright notice modal -->

    <ng-template #sugarcopyright let-modal>

        <div class="copyright-sugarcrm" role="dialog" aria-hidden="true">
            <div class="modal-header">
                <h5 class="modal-title">&copy; Powered By SugarCRM</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="modal.dismiss('Cross click')">
                    <scrm-image class="sicon" image="icon_modal_close"></scrm-image>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    &copy; 2004-2013 SugarCRM Inc. The Program is provided AS IS, without
                    warranty. Licensed under AGPLv3.
                </p>
                <p>
                    This program is free software; you can redistribute it and/or modify
                    it under the terms of the GNU Affero General Public License version
                    3 as published by the Free Software Foundation, including the
                    additional permission set forth in the source code header.
                </p>
                <p>
                    SugarCRM is a trademark of SugarCRM, Inc. All other company and
                    product names may be trademarks of the respective companies with
                    which they are associated.
                </p>
            </div>
        </div>

    </ng-template>

    <!-- End of SugarCRM Copyright notice modal -->

    <!-- Start of SuiteCRM Copyright notice modal -->

    <ng-template #suitecopyright let-modal>

        <div class="copyright-suitecrm" role="dialog" aria-hidden="true">
            <div class="modal-header">
                <h5 class="modal-title">&copy; Supercharged by SuiteCRM</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="modal.dismiss('Cross click')">
                    <scrm-image class="sicon" image="icon_modal_close"></scrm-image>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    SuiteCRM has been written and assembled by SuiteCRM Ltd. The Program
                    is provided AS IS, without warranty. Licensed under AGPLv3.
                </p>
                <p>
                    This program is free software; you can redistribute it and/or modify
                    it under the terms of the GNU Affero General Public License version
                    3 as published by the Free Software Foundation, including the
                    additional permission set forth in the source code header.
                </p>
                <p>
                    SuiteCRM is a trademark of SuiteCRM Ltd. All other company and
                    product names may be trademarks of the respective companies with
                    which they are associated.
                </p>
            </div>
        </div>

    </ng-template>

    <!-- End of SuiteCRM Copyright notice modal -->
</div>

<!-- End of copyright modal section -->
